import React from "react";
import CounterCard from "./countercard";

const CounterCards = ({ cards }) => {
  return (
    <div className="container">
      <div className="row" >
        {cards.map(card => (
          <div className="col-md-3 p-1" key={card.path || card.name}>
            <CounterCard 
              name={card.name} 
              number={card.number} 
              icon={card.icon} 
              background={card.background} 
              linkto={card.linkto}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CounterCards;
